// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* overridden by src/lib/themes/guiHelpers.js */

.tw-news_news_kYK35 {
    background: var(--motion-tertiary);
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 0.375rem 0;
    gap: 0.5rem;
}

.tw-news_content_wg5Tp {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    flex-grow: 1;
    margin-left: 0.5rem;
}

.tw-news_icon_D0amv {
    margin-right: 0.375rem;
    flex-shrink: 0;
}

.tw-news_text_VMc__ {
    color: white;
    text-align: center;
}

.tw-news_text_VMc__ a {
    color: inherit;
}

.tw-news_close_Wx9qB {
    flex-shrink: 0;
    margin-right: 0.5rem;
}
`, "",{"version":3,"sources":["webpack://./src/components/menu-bar/tw-news.css"],"names":[],"mappings":"AAAA,+CAA+C;;AAE/C;IACI,kCAAkC;IAClC,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;IACtB,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,oBAAoB;AACxB","sourcesContent":["/* overridden by src/lib/themes/guiHelpers.js */\n\n.news {\n    background: var(--motion-tertiary);\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    padding: 0.375rem 0;\n    gap: 0.5rem;\n}\n\n.content {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: center;\n    flex-grow: 1;\n    margin-left: 0.5rem;\n}\n\n.icon {\n    margin-right: 0.375rem;\n    flex-shrink: 0;\n}\n\n.text {\n    color: white;\n    text-align: center;\n}\n\n.text a {\n    color: inherit;\n}\n\n.close {\n    flex-shrink: 0;\n    margin-right: 0.5rem;\n}\n"],"sourceRoot":""}]);
// Exports
export var news = `tw-news_news_kYK35`;
export var content = `tw-news_content_wg5Tp`;
export var icon = `tw-news_icon_D0amv`;
export var text = `tw-news_text_VMc__`;
export var close = `tw-news_close_Wx9qB`;
export default ___CSS_LOADER_EXPORT___;
